//COMMON:
export const NAME: string = "Navn";
export const DESCRIPTION: string = "Beskrivelse";
export const CANCEL: string = "Annuller";
export const EDIT: string = "Ændr";
export const PARENT_ROLES: string = "Roller";
export const SUB_ROLES: string = "Underroller";
export const REPORTS: string = "Rapporter";
export const PRIVILEGES: string = "Rettigheder";
export const NORLYS: string = "Norlys";
export const DELETE: string = "Slet";
export const CREATED: string = "Oprettet";
export const ERROR_TITLE: string = "Fejl";
export const ERROR_MESSAGE: string = "Der er opstået en ukendt fejl.";

//PARENT ROLE - GENERAL:
export const PARENT_ROLE_CREATE: string = "Opret Rolle";

//PARENT ROLE - DIALOG:
export const OTHER_PRIVILEGES: string = "Yderligere Rettigheder";
export const PARENT_ROLE_EDIT: string = "Ændr Rolle";
export const NO_PRIVILEGES: string =
  "Underrollen har ingen rettigheder tilknyttet";
export const NO_DESCRIPTION: string =
  "Rettigheden har ingen beskrivelse tilknyttet";

//PARENT ROLE - PAGE:
export const PARENT_ROLE_SEARCH: string = "Søg efter rolle...";
export const PARENT_ROLE_OVERVIEW: string = "Rollevisning";
export const PARENT_ROLE_CATALOGUE: string = "Rollekatalog";
export const PARENT_ROLE_DELETE: string = "Slet Rolle";
export const PARENT_ROLE_DELETE_CONFIRMATION: string =
  "Er du sikker på, at du vil slette denne rolle?";
export const PARENT_ROLE_CREATE_ERROR: string =
  "Der opstod en fejl i forbindelse med at oprette en rolle. Tjek om det indtastede navn allerede bliver brugt på en anden rolle.";
export const PARENT_ROLE_UPDATE_ERROR: string =
  "Der opstod en fejl i forbindelse med at ændre en rolle. Tjek om det indtastede navn allerede bliver brugt på en anden rolle.";

//SUB ROLE - PAGE:
export const SUB_ROLE_SEARCH: string = "Søg efter underrolle...";
export const SUB_ROLE_DELETE: string = "Slet Underrolle";
export const SUB_ROLE_DELETE_CONFIRMATION: string =
  "Er du sikker på, at du vil slette denne underrolle?";
export const SUB_ROLE_CREATE_ERROR: string =
  "Der opstod en fejl i forbindelse med at oprette en underrolle. Tjek om det indtastede navn allerede bliver brugt på en anden underrolle.";
export const SUB_ROLE_UPDATE_ERROR: string =
  "Der opstod en fejl i forbindelse med at ændre en underrolle. Tjek om det indtastede navn allerede bliver brugt på en anden underrolle.";

//SUB ROLE - GENERAL:
export const SUB_ROLE_EDIT: string = "Ændr Underrolle";
export const SUB_ROLE_CREATE: string = "Opret Underrolle";

//PRIVILEGE - GENERAL:
export const PRIVILEGE_CREATE: string = "Opret Rettighed";

//PRIVILEGE - DIALOG:
export const PRIVILEGE_REFERENCE_NAME: string = "Referencenavn";
export const PRIVILEGE_ASSIGNABLE_BY: string = "Kan tildelse af";
export const PRIVILEGE_ALL_ORGANIZATIONS: string = "Alle Organisationer";

//PRIVILEGE - PAGE:
export const PRIVILEGE_SEARCH: string = "Søg efter rettighed...";
export const PRIVILEGE_EDIT: string = "Ændr Rettighed";
export const PRIVILEGE_DELETE: string = "Slet Rettighed";
export const PRIVILEGE_DELETE_CONFIRMATION: string =
  "Er du sikker på, at du vil slette denne rettighed?";
export const PRIVILEGE_CREATE_ERROR: string =
  "Der opstod en fejl i forbindelse med at oprette en rettighed. Tjek om det indtastede navn eller referencenavn allerede bliver brugt på en anden rettighed.";
export const PRIVILEGE_UPDATE_ERROR: string =
  "Der opstod en fejl i forbindelse med at ændre en rettighed. Tjek om det indtastede navn allerede bliver brugt på en anden rettighed.";
